import React from "react"
import "./TextArea.css"

function TextArea({ label, placeHolder, name, onChange, error, success }) {
  return (
    <span
      className={`TextArea ${error ? "error" : ""} ${success ? "success" : ""}`}
    >
      {label ? <label>{label}</label> : null}
      <textarea placeholder={placeHolder} name={name} onChange={onChange} />
      {error ? <p>{error}</p> : null}
    </span>
  )
}

export default TextArea
